<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    fill="none"
  >
    <g id="icon">
      <path
        d="M10.5,2.5l7,7v7c0,1.1,-0.9,2,-2,2h-7l-7,-7v-2l7,-7c0.55,-0.55,1.45,-0.55,2,0z"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="7"
        cy="10"
        r="1.2"
        stroke="currentColor"
        stroke-width="1"
      />
      <line
        x1="11"
        y1="9"
        x2="16"
        y2="14"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
      />
      <line
        x1="11"
        y1="12"
        x2="14"
        y2="15"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
